import { Outlet } from "react-router-dom";
import NavigationBar from "./navigation-bar";
import useOnline from "@/hooks/use-online";
import { useGetAllQueriesAtOnce } from "@/services/queries";
import AuthCheckProvider from "@/providers/auth-check-provider";
import useAuth from "@/store/use-auth";
import { useEffect, useMemo } from "react";
import { getCurrentUserFromStorage } from "@/lib/api";
import useVessel from "@/store/use-vessel";
import { useGetVessels } from "@/services/queries/vessel";

const MainLayout = () => {
  const online = useOnline();
  const { setUser } = useAuth();
  useGetAllQueriesAtOnce({ enabled: online });

  const { selectedVessel, setSelectedVessel } = useVessel();
  const { data } = useGetVessels();
  const vessels = useMemo(() => {
    return data?.value || [];
  }, [data]);

  useEffect(() => {
    if (selectedVessel) return;

    const storedBoat = localStorage.getItem("selected_vessel");
    if (storedBoat) {
      const vessel = vessels.find((vessel) => vessel.id === storedBoat);
      if (vessel) {
        setSelectedVessel(vessel);
      } else {
        if (vessels.length > 0) {
          localStorage.setItem("selected_vessel", vessels[0].id);
          setSelectedVessel(vessels[0]);
        }
      }
    } else {
      if (vessels.length > 0) {
        localStorage.setItem("selected_vessel", vessels[0].id);
        setSelectedVessel(vessels[0]);
      }
    }
  }, [selectedVessel, setSelectedVessel, vessels]);

  useEffect(() => {
    const userInfo = getCurrentUserFromStorage();
    if (userInfo) {
      setUser(userInfo);
    }
  }, [setUser]);

  return (
    <AuthCheckProvider>
      <div
        style={{
          backgroundImage:
            "url('/images/layout-bg.png'), linear-gradient(45deg, #041935, #041935)",
        }}
        className="h-auto min-h-screen w-screen bg-cover bg-center bg-no-repeat pb-24 pt-10 md:bg-cover md:bg-center"
      >
        <Outlet />
        <NavigationBar />
      </div>
    </AuthCheckProvider>
  );
};

export default MainLayout;
